// Shared regex + validation helpers for the wizard's "Your Details" step.
// Keeping these here lets BookingWizard and Step3Details share one source of truth.
export const PHONE_RE = /^\d{3}-\d{3}-\d{4}$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateDetails(details) {
  const errors = {};
  if (!details.owner_first_name.trim()) errors.owner_first_name = "First name is required";
  if (!details.owner_last_name.trim()) errors.owner_last_name = "Last name is required";
  if (!PHONE_RE.test(details.owner_phone)) errors.owner_phone = "Use format 306-555-1234";
  if (!EMAIL_RE.test(details.owner_email)) errors.owner_email = "Enter a valid email address";
  if (!details.pet_name.trim()) errors.pet_name = "Pet name is required";
  if ((details.pet_notes || "").length > 300) errors.pet_notes = "Notes must be 300 characters or less";
  return errors;
}

export function detailsAreValid(details) {
  return Object.keys(validateDetails(details)).length === 0;
}
